import React from 'react';

// template components

// template components
import Col from '@nmx/template/dist/componentLibrary/foundations/Grid/Col';
import Row from '@nmx/template/dist/componentLibrary/foundations/Grid/Row';
import SectionContainer from '@nmx/template/dist/componentLibrary/components/SectionContainer';
import Typography from '@nmx/template/dist/componentLibrary/foundations/Typography';

export default () => {
  return (
    <SectionContainer
      id='financial-information-clients-first'
      backgroundVariant='lightB'
      themeType='lightTheme'
      disableBottomPadding>
      <Row align='center'>
        <Col medium={8}>
          <Typography
            component='h2'
            align='center'
            nextElement='typography'>
            We put clients first.
          </Typography>
          <Typography disableBottomPadding>
            &#34;We succeed when you succeed.&#34; For more than 160 years, we&#39;ve been an industry leader by holding true to this simple principle. By managing our business effectively and acting in the best Long&#45;Term interest of our clients, we&#39;re able to offer excellent product value and service for a lifetime of financial security.
          </Typography>
        </Col>
      </Row>
    </SectionContainer>
  );
};
